export default __webpack_public_path__ + "static/media/m_slide_btn_left.6ab07c7f.png";